<template>
  <div
    class="
      is-align-items-center
      is-flex
      is-flex-direction-column
      is-justify-content-center
      mb-large
    "
  >
    <div class="mb-9">
      <h1 class="has-text-black has-text-weight-light is-size-3 mb-4">
        快速建立帳戶
      </h1>
      <p class="has-text-centered">
        已有帳戶？
        <router-link class="link-decoration-none has-text-primary login" to="/login">
          立即登入
        </router-link>
      </p>
    </div>
    <form class="first-step__fields px-5">
      <b-field
        :message="getIdentificationMsg"
        :type="{ 'is-danger': hasIdentificationError }"
      >
        <b-input
          :use-html5-validation="false"
          v-model="form.identification"
          placeholder="請輸入統一編號"
          ref="identificationInput"
          type="number"
          @blur="v$.form.identification.$touch"
        />
      </b-field>
      <b-field
        :message="getAccountMsg"
        :type="{ 'is-danger': hasErrorMsgs('account') }"
      >
        <b-input
          :use-html5-validation="false"
          v-model="form.account"
          placeholder="請設定登入帳號"
          type="text"
          @blur="v$.form.account.$touch"
        />
      </b-field>
      <b-field
        :message="getErrorMsgs('email')"
        :type="{ 'is-danger': hasErrorMsgs('email') }"
      >
        <b-input
          :use-html5-validation="false"
          v-model="form.email"
          placeholder="請輸入電子郵件"
          type="email"
          @blur="v$.form.email.$touch"
        />
      </b-field>

      <b-field
        :message="getPasswordMsg"
        :type="{ 'is-danger': hasErrorMsgs('password') }"
      >
        <b-input
          :use-html5-validation="false"
          v-model="form.password"
          password-reveal
          placeholder="請輸入密碼"
          type="password"
          @blur="v$.form.password.$touch"
        />
      </b-field>
      <b-checkbox v-model="form.subscribed_weiby" class="has-text-black my-4">
        是的，我願意接收好彙訂訊息以獲得最新活動等資訊
      </b-checkbox>
      <b-button
        :disabled="v$.form.$invalid && v$.form.$dirty"
        class="mt-large"
        expanded
        type="is-primary"
        @click="next"
      >
        繼續
      </b-button>
    </form>
  </div>
</template>

<script>
import FirstStep from './FirstStep';

export default FirstStep;
</script>

<style lang="scss" scoped>
@import 'FirstStep';
</style>
